$(document).ready(function(){


    function addLink() {
        //Get the selected text and append the extra info
        var selection = window.getSelection(),
            pagelink = '<br /><br /> Skaitykite daugiau: ' + document.location.href,
            copytext = selection + pagelink,
            newdiv = document.createElement('div');

        //hide the newly created container
        newdiv.style.position = 'absolute';
        newdiv.style.left = '-99999px';

        //insert the container, fill it with the extended text, and define the new selection
        document.body.appendChild(newdiv);
        newdiv.innerHTML = copytext;
        selection.selectAllChildren(newdiv);

        window.setTimeout(function () {
            document.body.removeChild(newdiv);
        }, 100);
    }

    document.addEventListener('copy', addLink);

    $('.copy-link').on('click', function () {
        $('#url').select();
        document.removeEventListener('copy', addLink);
        document.execCommand("copy");
        document.addEventListener('copy', addLink);
    });

    $('.copy-edit-link').on('click', function () {
        $('#urledit').select();
        document.removeEventListener('copy', addLink);
        document.execCommand("copy");
        document.addEventListener('copy', addLink);
    });

    addToHomescreen({
        lifespan: 0,
        icon: false,
        maxDisplayCount: 2,
        message: '<div class="text">Pridėkite naujienos.lt prie savo mėgstamiausių!</div><div class="icon"></div>'
    });

    var ajaxUrl = ranAdminUrl;

    if ($('body').hasClass('home')) {
        var weatherData = '';
        var weatherText = '';

        $.ajax({
            url: ajaxUrl + "?action=get_weather_data"
        }).done(function( response ) {
            weatherData = response;

            $.ajax({
                url: ajaxUrl + "?action=get_geocode_data"
            }).done(function( response ) {
                weatherText = response.results[2].address_components[0].short_name;

                response.results.forEach(function(element){
                    element.address_components.forEach(function(element2){
                        element2.types.forEach(function(element3){
                            switch(element3){
                                case 'locality':
                                    weatherText = element2.long_name;
                                    $('.weather-date.to-change').html(weatherText)
                                    break;
                            }
                        })
                    });
                });

            });

            $.each( weatherData.daily.data, function( key, value ) {
                var unixTime = value.time;
                var date = moment.unix(unixTime).tz('Europe/Vilnius').locale('lt').format('ddd MM-DD');

                var tempHigh = Math.round(value.temperatureMax)
                var tempLow = Math.round(value.temperatureMin)
                var wind = Math.round(value.windSpeed)

                if (key < 4) {
                    if (key == 0) {
                        $('.weather-home').append('' +
                            '<div class="weather-block weather-today clearfix">' +
                                '<div class="icon"><img src="/content/themes/ran/assets/img/weather/' + value.icon + '.svg" alt="' + value.icon + '"></div>' +
                                '<div class="info-wrap">' +
                                    '<div class="weather-date to-change"></div>' +
                                    '<div class="weather-data">' +
                                        '<span class="temp-high">' + tempHigh + '&deg;</span>' +
                                        '<span class="temp-low">' + tempLow + '&deg;</span>' +
                                        '<span class="wind"><span class="wind-icon" style="transform: rotate(' + value.windBearing + 'deg)"></span>' + wind + 'm/s</span>' +
                                    '</div>' +
                                '</div>' +
                            '</div>')
                    } else {
                        $('.weather-home').append('' +
                            '<div class="weather-block weather-today">' +
                                '<div class="info-wrap">' +
                                    '<div class="weather-date">' + date + '</div>' +
                                    '<div class="weather-data">' +
                                        '<span class="temp-high">' + tempHigh + '&deg;</span>' +
                                        '<span class="temp-low">' + tempLow + '&deg;</span>' +
                                    '</div>' +
                                '</div>' +
                            '</div>')
                    }
                }
            });
        });
    }

    $('.mob-trigg').on('click', function (e) {
        if (e.target === this){
            $('.mobshepard-overlay').removeClass('shep-active');
            $('.mobile-header').removeClass('shep-active');
            if ($(this).hasClass('active')) {
                $('.menu-active-overlay').removeClass('active');
                $('.mob-trigg').removeClass('active');
            } else {
                $('.menu-active-overlay').addClass('active');
                $('.mob-trigg').removeClass('active');
                $(this).addClass('active');
                $('.mob-cat-trigg').removeClass('active');
            }
        }
    });

    $('.close-exp').on('click', function () {
        $('.menu-active-overlay').removeClass('active');
        $('.mob-trigg').removeClass('active');
    });
    
    $('.mob-cat-trigg').on('click', function (e) {
        if (e.target === this){
            if ($(this).hasClass('active')) {
                $('.menu-active-overlay').removeClass('active');
                $('.mob-cat-trigg').removeClass('active');
            } else {
                $('.menu-active-overlay').addClass('active');
                $('.mob-trigg').removeClass('active');
                $(this).addClass('active');
            }
        }
    });

    $('.search-trigg').on('click', function () {
        $(this).parent().toggleClass('active');
    });

    $('#searchform').on('submit', function (e) {
        if ($(this).find('input:first-of-type').val() == '') {
            e.preventDefault();
            $('.search-trigg').click();
        }
    });

    $('.fancybox').fancybox({
        helpers:  {
            title : {
                type : 'inside'
            }
        }
    });


    if ($('.article-slider .top').length > 0) {
        var desktopSlider = $('.article-slider .top');

        desktopSlider.owlCarousel({
            items : 1,
            loop: true,
            autoplay: true,
            autoplayHoverPause: true,
            mouseDrag: false
        });

        desktopSlider.on('changed.owl.carousel', function(event) {
            var which = +event.page.index + 1;
            $('.bottom-tab').removeClass('active');
            $('.bottom-tab:nth-of-type(' + which + ')').addClass('active');
        });

        $('.bottom-tab').on('click', function () {
            var which = $(this).index();

            desktopSlider.trigger("to.owl.carousel", which);
            $('.bottom-tab').removeClass('active');
            $(this).addClass('active');
        });
    }

    if ($('.desktop-hero').length > 0) {
        var desktopHeroSlider = $('.desktop-hero .owl-carousel');

        desktopHeroSlider.owlCarousel({
            center : true,
            loop: true,
            items: 2,
            autoWidth: true,
            nav: true,
            autoplay: true,
            autoplayHoverPause: true,
            mouseDrag: false
        });
    }

    var isiPad = navigator.userAgent.match(/iPad/i) != null;
    if (isiPad) {document.getElementsByTagName("body")[0].className+=" ipad";}

    var carousel = $('.news-slider');

    carousel.owlCarousel({
        items : 3,
        nav : true,
        navRewind: false
    });

    $('.mobile-hero-slider').owlCarousel({
        items: 1,
        nav : true,
        navRewind: true,
        loop: true,
        autoplay: true
    });

    $('.articles-slider').owlCarousel({
        autoWidth: true
    });

    $('.custom-articles-slider').owlCarousel({
        autoWidth: true,
        responsive : {
            768 : {
                autoWidth: false,
                margin: 10,
                nav: true
            }
        }
    });

    if ($('.article--hero').length > 0) {

        var animAction = false;

        $('.article--hero_nav li').on('click', function () {
            var self = $(this);
            var toOpen = self.data('show');
            var image = self.data('image');
            var position = self.data('position');

            if (!animAction) {
                if (!self.hasClass('active')) {
                    animAction = true;
                    // $('.article--hero_nav li').removeClass('active');
                    // self.addClass('active');
                    setTimeout(function(){ animAction = false }, 500);
                    $('header.article--hero').css('background-image', 'url("' + image + '")');
                    $('header.article--hero').removeClass('image-left-top image-center-top image-right-top image-left-center image-center-center image-right-center image-left-bottom image-center-bottom image-right-bottom');
                    $('header.article--hero').addClass(position);
                    $('.vcell.active').hide().removeClass('active');
                    $('.' + toOpen).show().addClass('active');
                }
            }
        });

        var sliding = true;

        function slideHero() {
            var current = $('body').find('.article--hero_content .vcell.active .article--hero_nav li.active');
            var next = current.next();
            var last = $('.article--hero_content .vcell.active .article--hero_nav li:last-of-type');
            var toClick = next;
            var count = $('.article--hero_content .vcell.active .article--hero_nav li').length;

            if (current.index() == (count - 1)) {
                toClick = $('.article--hero_content .vcell.active .article--hero_nav li:first-of-type');
            }

            if (sliding) {
                toClick.click();
            }
        }

        window.setInterval(slideHero, 5000);

        $('.next-slide').on('click', function () {
            var current = $('body').find('.article--hero_content .vcell.active .article--hero_nav li.active');
            var next = current.next();
            var last = $('.article--hero_content .vcell.active .article--hero_nav li:last-of-type');
            var toClick = next;
            var count = $('.article--hero_content .vcell.active .article--hero_nav li').length;

            if (current.index() == (count - 1)) {
                toClick = $('.article--hero_content .vcell.active .article--hero_nav li:first-of-type');
            }

            toClick.click();
        });

        $('.prev-slide').on('click', function () {
            var current = $('body').find('.article--hero_content .vcell.active .article--hero_nav li.active');
            var toClick = current.prev();

            if (current.index() == 0) {
                toClick = $('.article--hero_content .vcell.active .article--hero_nav li:last-of-type');
            }

            toClick.click();
        });

        $('header.article--hero, header.article--hero *').mouseover(function(){
            sliding = false;
        }).mouseout(function(){
            sliding = true;
        });

    }

    // LOCATION BUTTON SWAP TEXT

    var button_loc = $('.btn--location');

    // button_loc.mouseup(function() {
    //     var el = $(this);
    //     el.text(el.data("text-original"));
    // });

    // button_loc.mousedown(function() {
    //     var el = $(this);
    //     el.data("text-original", el.text());
    //     el.text(el.data("active"));
    // });

    // EXPANDING SEARCH BAR

    $('.sb-icon-search').click(function(){
       $('.sb-search').toggleClass('sb-search-open');
    });

    $('#clickjur').on('click', function () {
        $('.showjur').show();
    });

    $('#clickfiz').on('click', function () {
        $('.showjur').hide();
    });

    $('#prenum-forma').submit(function () {
        var validatable = $('#prenum-forma .required');
        var isValid = true;

        validatable.each(function () {
            $(this).removeClass('not-valid');

            var value = $(this).val();

            if (value == '') {
                $(this).addClass('not-valid');
                isValid = false;
            }
        });

        return isValid;
    });

    // SELECT BOXES

    var sel = $(".location-select").select2({
        dropdownParent: $('#select-dropdown')
    });

    var selAu = $(".author-select").select2({
        dropdownParent: $('#author-select-dropdown')
    });

    var selleidinys = $(".leidinys select").select2({
        dropdownParent: $('.leidinys select').parent(),
        minimumResultsForSearch: Infinity
    });
    var selpnuo = $(".pnuo select").select2({
        dropdownParent: $('.pnuo select').parent(),
        minimumResultsForSearch: Infinity
    });
    var selpiki = $(".piki select").select2({
        dropdownParent: $('.piki select').parent(),
        minimumResultsForSearch: Infinity
    });
    var selmailbox = $(".mailbox select").select2({
        dropdownParent: $('.mailbox select').parent(),
        minimumResultsForSearch: Infinity
    });

    selmailbox.on('select2:open', function () {
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar();
        }, 1);
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar('update');
        }, 2);
        setTimeout(function () {
            $(".select2-results__options").css('padding-right', '1px');
        }, 3);
    });


    selpiki.on('select2:open', function () {
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar();
        }, 1);
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar('update');
        }, 2);
        setTimeout(function () {
            $(".select2-results__options").css('padding-right', '1px');
        }, 3);
    });

    selpnuo.on('select2:open', function () {
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar();
        }, 1);
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar('update');
        }, 2);
        setTimeout(function () {
            $(".select2-results__options").css('padding-right', '1px');
        }, 3);
    });

    selleidinys.on('select2:open', function () {
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar();
        }, 1);
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar('update');
        }, 2);
        setTimeout(function () {
            $(".select2-results__options").css('padding-right', '1px');
        }, 3);
    });

    sel.on('select2:open', function () {
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar();
        }, 1);
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar('update');
        }, 2);
        setTimeout(function () {
            $(".select2-results__options").css('padding-right', '1px');
        }, 3);
    });

    selAu.on('select2:open', function () {
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar();
        }, 1);
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar('update');
        }, 2);
        setTimeout(function () {
            $(".select2-results__options").css('padding-right', '1px');
        }, 3);
    });

    // RANGE SLIDER

    if ($('.range-slider-wrap').length > 0) {
        var connectSlider = document.getElementById('range-slider');
        connectSliderStart = ranJsVariables.range;

        noUiSlider.create(connectSlider, {
            start: connectSliderStart,
            connect: 'lower',
            range: {
                'min': 1,
                'max': 150
            }
        });


        function createSliderSpan() {
            var circle = $('.noUi-horizontal.noUi-extended .noUi-handle');
            circle.append("<span></span>")
        }

        createSliderSpan();

        var stepSliderValueElement = document.getElementById('range-slider-value');

        connectSlider.noUiSlider.on('update', function( values, handle ) {
            stepSliderValueElement.innerHTML = values[handle].slice(0,-3) + 'km';

            var circle = $('.noUi-horizontal.noUi-extended .noUi-handle span');
            var value = values[handle].slice(0,-3) / 4 + 5;

            circle.css({"height":value + "px"});
            circle.css({"width":value + "px"});
        });

        var rangeSliderPrev = $('.range-slider-prev');
        var rangeSliderNext = $('.range-slider-next');

        rangeSliderPrev.click(function(){
            var value = Number( connectSlider.noUiSlider.get() );
            connectSlider.noUiSlider.set( value - 10 );
        });
        rangeSliderNext.click(function(){
            var value = Number( connectSlider.noUiSlider.get() );
            connectSlider.noUiSlider.set( value + 10 );
        });
    }



    // INPUT TAGS
    
    // $('.taglist li a').click(function(event){
    //     var select = $('.authors-block-select');
    //     var selected = $('.select2-selection__choice');
    //     var size = selected.size();
    //
    //     if(size < 1){
    //         var val = $(this).data('value');
    //         select.append('<option selected="selected" value="' + val + '">' + val + '</option>');
    //     }
    //     else{
    //         console.log("Cant add more than 1");
    //     }
    //     event.preventDefault();
    // });

    // TEXT OVERFLOW ELLIPSIS PLUGIN

    $('.ellipsis').ellipsis();

    // NAV TOGGLE

    $('.btn-nav-toggle').click(function(){
       $('.main-menu').slideToggle(200);
        $(this).toggleClass('active');
    });

    $('#commentform').submit(function (e) {
        var nameIn = $('#author');
        var commIn = $('#comment');
        var recaIn = $('.g-recaptcha');
        var valid = true;
        nameIn.removeClass('invalid');
        commIn.removeClass('invalid');
        recaIn.removeClass('invalid');

        if (nameIn.val() == '') {
            nameIn.addClass('invalid');
            valid = false;
        }

        if (commIn.val() == '') {
            commIn.addClass('invalid');
            valid = false;
        }

        var response = grecaptcha.getResponse();

        if(response.length == 0) {
            recaIn.addClass('invalid');
            valid = false;
        }

        if (!valid) {
            e.preventDefault();
        }
    });

    if ($(window).width() < 1340) {
        // console.log('true')
        // $('meta[name=viewport]').remove();
        // $('head').append( '<meta name="viewport" content="width=1320, user-scalable=no, initial-scale=0.5, maximum-scale=0.5">' );
    }

    $('.shep-tooltip .shep-close').on('click', function () {
        closeShep();
    });

    $('.mob-shep-tooltip .shep-close').on('click', function () {
        $('.mobshepard-overlay').removeClass('shep-active');
        $('.mobile-header').removeClass('shep-active');
    });

    if ($(window).width() < 768) {
        if (!localStorage.getItem('naujienosShepardMob')) {
            $('.mobshepard-overlay').addClass('shep-active');
            $('.mobile-header').addClass('shep-active');
            localStorage.setItem('naujienosShepardMob', true);
        }
    }

    var leftWidth = (($(window).width() - $('body > .container').outerWidth()) / 2) + 5;
    var rightWidth = (($(window).width() - $('body > .container').outerWidth()) / 2) + 15;
    $('.bnrleft').css('left', (leftWidth - 450));
    $('.bnrright').css('right', (rightWidth -450));


    $('.leidiniai .lspan').on('click', function (e) {
        if (e.target === this) {
            $('.leidiniai .mob-exp').toggleClass('active');
            $('.leidiniai .lspan').toggleClass('active');
        }
    });
    $('.leidiniai .close-exp').on('click', function (e) {
        $('.leidiniai .mob-exp').removeClass('active');
        $('.leidiniai .lspan').removeClass('active');
    });
});

function showShep() {
    if ($('body').hasClass('home')) {
        if (!localStorage.getItem('naujienosShepard')) {
            $('.shepard-overlay').addClass('shep-active');
            $('.block--location').addClass('shep-active');
            localStorage.setItem('naujienosShepard', true);
        }
    }
}

function closeShep() {
    $('.shepard-overlay').removeClass('shep-active');
    $('.block--location').removeClass('shep-active');
}



$(window).on('scroll', function(){
    if ($(this).scrollTop() > 79) {
        $('.head-nav').addClass('active');
    } else {
        $('.head-nav').removeClass('active');
    }

    if ($('body').hasClass('home')) {
        if (($(this).scrollTop() > ($('.block--location').offset().top / 2)) && ($(this).scrollTop() < $('.block--location').offset().top - 200) && $(window).width() > 767) {
            showShep();
        }
    }


    var $el = $('.sticky-ad');
    if ($el.length > 0) {
        if ($(this).scrollTop() < ($el.offset().top + 10)) {
            $el.css({'position': 'static', 'top': '10px'});
        }
        if ($(this).scrollTop() > ($el.offset().top + 10)){
            $el.css({'position': 'fixed', 'top': '10px'});
        }
    }
});

( function ( document, window, index )
{
    'use strict';

    var elSelector	= '#top-bar',
        element		= document.querySelector( elSelector );

    if( !element ) return true;

    var elHeight		= 0,
        elTop			= 0,
        dHeight			= 0,
        wHeight			= 0,
        wScrollCurrent	= 0,
        wScrollBefore	= 0,
        wScrollDiff		= 0;

    var adHeight = $('.ad-top').outerHeight();

    var loaded = false;

    function setHeight() {
        if ($(window).width() < 768) {
            adHeight = adHeight - 140
        } else if (($(window).width() > 767) && ($(window).width() < 1280)) {
            adHeight = adHeight - 112
        } else if ($(window).width() > 1279) {
            adHeight = adHeight - 123
        }

        if ($('.ad-top').outerHeight() < 0) {
            adHeight = 0;
            loaded = true;
        } else if ($('.ad-top').outerHeight() == 30) {
            setTimeout(function(){ setHeight() }, 100);
        } else if ($('.ad-top').outerHeight() > 30) {
            loaded = true;
        }
    }

    setHeight();

    if (window.pageYOffset > adHeight) {
        $('#top-bar').css('top', 0)
    } else {
        if (window.pageYOffset == 0) {
            $('#top-bar').css('top', adHeight)
        } else {
            $('#top-bar').css('top', (adHeight - window.pageYOffset))
        }
    }

    window.addEventListener( 'scroll', function()
    {
        elHeight		= element.offsetHeight;
        dHeight			= document.body.offsetHeight;
        wHeight			= window.innerHeight;
        wScrollCurrent	= window.pageYOffset;
        wScrollDiff		= wScrollBefore - wScrollCurrent;
        elTop			= parseInt( window.getComputedStyle( element ).getPropertyValue( 'top' ) ) + wScrollDiff;

        if( wScrollCurrent <= adHeight ) { // scrolled to the very top; element sticks to the top
            element.style.top = ((wScrollCurrent - adHeight) * -1) + 'px';
        }

        else if( wScrollDiff > 0 ) // scrolled up; element slides in
            element.style.top = ( elTop > 0 ? 0 : elTop ) + 'px';

        else if( wScrollDiff < 0 ) // scrolled down
        {
            if( wScrollCurrent + wHeight >= dHeight - elHeight )  // scrolled to the very bottom; element slides in
                element.style.top = ( ( elTop = wScrollCurrent + wHeight - dHeight ) < 0 ? elTop : 0 ) + 'px';

            else // scrolled down; element slides out
                element.style.top = ( Math.abs( elTop ) > elHeight ? -elHeight : elTop ) + 'px';
        }

        wScrollBefore = wScrollCurrent;
    });

}( document, window, 0 ));

$(window).on('resize', function(){

    var leftWidth = (($(window).width() - $('#top-bar').next().outerWidth()) / 2) + 5;
    var rightWidth = (($(window).width() - $('#top-bar').next().outerWidth()) / 2) + 15;
    $('.bnrleft').css('left', (leftWidth - 450));
    $('.bnrright').css('right', (rightWidth -450));
});
